<template>
  <div
    id="create-creative-modal"
    class="card mb-5"
  >
    <div class="card-body">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>{{ $t('add_creative') }}</span>
        </h2>
      </div>
      <AlertWraper
        :content="content"
        :type="content_type"
      />
      <div class="text-center mt-3">
        <UpsertCreativeForm
          :advertiserId="advertiserId"
          :format="format"
          @creative-created="handleCreated"
          @upsert-creative-error="handleError"
          @format-selected="handleFormatSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import UpsertCreativeForm from '@/components/creatives/UpsertCreativeForm'

export default {
  name: 'CreateCreative',
  props: ['advertiserId', 'format'],
  components: {
    AlertWraper,
    UpsertCreativeForm
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error',
      selected_format: ''
    }
  },
  computed: {
    modalClasses () {
      const classes = ['default-modal']

      if (
        this.selected_format === 'NATIVE_DISPLAY' ||
        this.format === 'NATIVE_DISPLAY' ||
        this.selected_format === 'PUSH' ||
        this.format === 'PUSH'
      ) classes.push('modal-size-lg')

      return classes.join(' ')
    }
  },
  methods: {
    /**
     * Handle created
     */
    handleCreated () {
      this.$emit('creative-created')
      this.hidden()
    },
    /**
     * Handle error
     */
    handleError (error) {
      this.content = parseErrorResponseToArray(error)
    },
    /**
     * Handle format selected
     */
    handleFormatSelected (format) {
      this.selected_format = format
    },
    /**
     * Hidden
     */
    hidden () {
      this.content = null
      this.selected_format = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
